<template>
  <div class="user-info">
    <div class="user-info-no-log" v-if="!userInfo" @click="handleLogin">
      <a href="javascript:void(0)">登录</a>
    </div>
    <div class="user-info-had-log" v-else>
      <lr-link
        class="user-info-avatar"
        to="/user/index.html"
        @click="handleAvatarClick"
        @mouseover="handleAvatarMouseOver"
      >
        <img :src="userInfo.pic" />
      </lr-link>
      <div class="user-info-login-menu">
        <lr-link to="/user/index.html">
          <div class="user-info-login-menu-profile">
            <img :src="userInfo.pic" />
            <span class="user-info-login-menu-profile-nickname">{{
              userInfo.nickname
            }}</span>
          </div>
        </lr-link>
        <ul>
          <li
            class="user-info-login-menu-item"
            @click="handleItemClick('subscription')"
          >
            <lr-link to="/user/index.html#/profile-user-learning">
              <icon type="learning"></icon>
              我的学习
              </lr-link>
          </li>
          <li
            class="user-info-login-menu-item"
            @click="handleItemClick('collect')"
          >
            <lr-link to="/user/index.html#/profile-collect">
              <icon type="collect"></icon>
              我的收藏
              </lr-link
            >
          </li>
          <li
            class="user-info-login-menu-item logout"
            @click="handleItemClick('out')"
          >
            <a @click="handleLogout"> 退出 </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="user-info-log-frame" v-if="isShowLogin">
      <div class="user-info-log-frame-box">
        <icon
          class="user-info-log-frame-close"
          type="iconic_cancel_pop"
          @click="handleCloseFrame"
        ></icon>

        <iframe :src="loginSrc"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { isInWps } from '@/common/utils';
import account from '@wps/wps_client_api/account';

export default {
  data() {
    return {
      isShowLogin: false,
      loginSrc: '',
    };
  },

  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
  },

  watch: {
    userInfo: {
      handler(val) {
        if (val) {
          this.$collect.detailsPersonalShow({ show: 'head' });
        }
      },
    },
  },

  methods: {
    handleLogin(from) {
      if (!from) {
        this.$collect.centerSigninClick({ source: 1 });
      }

      if (isInWps()) {
        // 执行wps环境内的逻辑
        account.login({ extraParams: { qrcode: 'wps' } });
      } else {
        // 执行非wps环境内的逻辑
        let url = location.href;

        // 个人云登录框在登录后返回到当前页面时，如果有哈希值，会无法返回的，这里去掉url后面的hash
        url = url.replace(/#.*/, '');

        const href =
          'https://account.wps.cn/v1/minilogin?cb=' +
          encodeURIComponent(url) +
          '&qrcode=wps&from=wps%E5%AD%A6%E9%99%A2&reload=true';
        this.loginSrc = href;
        this.isShowLogin = true;
      }
    },

    async handleLogout() {
      if (isInWps()) {
        account.logout();
      } else {
        await this.$service.auth.logout();
        this.$store.dispatch('user/logout');
      }
    },

    handleCloseFrame() {
      this.isShowLogin = false;
    },

    handleAvatarClick() {
      this.$collect.detailsPersonalClick({ hover: 'head' });
    },

    handleAvatarMouseOver() {
      this.$collect.detailsPersonalShow({ show: 'headhover' });
    },

    handleItemClick(value) {
      this.$collect.detailsPersonalClick({ hover: value });
    },
  },

  mounted() {
    this.$eventBus.$on('login', (from) => {
      this.handleLogin(from);
    });
  },
};
</script>

<style lang="scss" scoped>
.user-info {
  @include flex-align-center();
  height: 100%;

  &-no-log {
    width: 88px;
    height: 32px;
    background: #2c71fa;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background: #2786f2;
    }
    &:active:not(:disabled) {
      background: #1c53d4;
    }
  }

  &-no-log > a {
    display: block;
    cursor: pointer;
    font-size: 14px;
    color: #ffffff;
    line-height: 22px;
  }

  &-had-log {
    @include flex-center();
    position: relative;
    height: 100%;

    &:hover {
      .user-info-login-menu {
        display: block;
        animation: fade 0.2s;
      }
    }
  }

  &-avatar {
    display: block;
    cursor: pointer;

    & > img {
      display: block;
      width: 32px;
      height: 32px;
      border-radius: 18px;
      border: 2px solid rgba(0, 0, 0, 0.08);
    }
  }

  &-login-menu {
    display: none;
    position: absolute;
    @include dropdown-style();
    border: 1px solid rgba(17, 19, 23, 0.1);
    top: 52px;
    right: -68px;
    width: 168px;
    padding: 4px;
    &-item {
      padding: 5px 8px;
      list-style: none;
      text-align: left;
      line-height: 22px;
      box-sizing: border-box;
      cursor: pointer;
      margin-bottom: 2px;
      .icon {
        font-size: 20px;
        color: #D0D3D8;
      }

      &:hover {
        background: rgba(8, 48, 93, 0.04);
        border-radius: 4px;
      }

      > a {
        color: #222226;
        display: flex;
        align-items: center;
      }

      &.logout {
        position: relative;
        margin-top: 8px;
        &::before {
          content: '';
          height: 1px;
          background: rgba(17, 19, 23, 0.05);
          width: 100%;
          position: absolute;
          left: 0;
          top: -4px;
        }
      }
    }

    &-profile {
      margin-top: 12px;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      cursor: pointer;

      > img {
        width: 32px;
        height: 32px;
        border-radius: 18px;
        display: inline-block;
        margin-right: 10px;
        margin-left: 8px;
      }

      &-nickname {
        font-size: 12px;
        color: #333840;
        line-height: 20px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  &-log-frame {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.5);

    &-box {
      position: absolute;
      width: 373px;
      height: 439px;
      top: 50%;
      left: 50%;
      margin-top: -230px;
      margin-left: -188px;
      color: #7a808a;
      background: #fff;

      > iframe {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
      }
    }

    &-close {
      @include close-btn-style();
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      font-size: 16px;
    }
  }
}
@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
